import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <main className="flex flex-col w-full">
      {/* <div className="flex justify-center w-full bg-gray-800">
        <div className="container flex flex-col md:flex-row justify-between w-full p-8 text-sm md:text-base">
          <div className="flex flex-col justify-between w-full py-6 md:py-0">
            <div className="flex flex-col">

              <Link to={"/"} className="font-bold text-2xl mb-4">DWQ Legal LLC(Dev)</Link>

              <Link to={"/privacy-policy"} className="text-gray-300 hover:text-white py-1">Privacy & Policy</Link>
              <Link to={"/terms-and-conditions"} className="text-gray-300 hover:text-white py-1">Terms & Conditions</Link>
            </div>

            <div>
              <p className="py-1">info@dwq.legal</p>
              <p className="py-1">+1 (866) 425-9564</p>
              <p className="py-1">P.O. Box 41150 Tucson, AZ 85717</p>
            </div>
          </div>

        </div>
      </div> */}

      <div className="flex justify-center items-center w-full p-6 bg-gray-900 flex-wrap mt-4">
        <Link to={"/"} className="font-bold text-xl text-gray-300 hover:text-white py-1 mr-3">DWQ Legal LLC</Link>
        <Link to={"/privacy-policy"} className="text-gray-300 hover:text-white py-1">Privacy & Policy</Link><span className="text-gray-500">&nbsp;|&nbsp;</span>
        <Link to={"/terms-and-conditions"} className="text-gray-300 hover:text-white py-1">Terms & Conditions</Link><span className="text-gray-500">&nbsp;|&nbsp;</span>
        <p className="py-1 text-gray-300">info@dwq.legal</p><span className="text-gray-500">&nbsp;|&nbsp;</span>
        <p className="py-1 text-gray-300">+1 (866) 425-9564</p><span className="text-gray-500">&nbsp;|&nbsp;</span>
        <p className="py-1 text-gray-300">P.O. Box 41150 Tucson, AZ 85717</p>
        {/* DWQ Legal, LLC © All rights reserved 2024 */}
      </div>
    </main>

  );
}
